import { render, staticRenderFns } from "./VsDropdownForm.vue?vue&type=template&id=2f4e7c79&scoped=true"
import script from "./VsDropdownForm.vue?vue&type=script&lang=js"
export * from "./VsDropdownForm.vue?vue&type=script&lang=js"
import style0 from "./VsDropdownForm.vue?vue&type=style&index=0&id=2f4e7c79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4e7c79",
  null
  
)

export default component.exports